import { AuthenticatedHttp } from '@/http/axios';
import { useQuery } from '@tanstack/react-query';
import { useNotify } from '@/components/snackbar';

export function useApiScopes(enabled = true) {
    const notify = useNotify();

    const getScopes = async () => {
        try {
            const { data } = await AuthenticatedHttp.get('/public_api/scopes/');
            return data;
        } catch (error) {
            notify.error('Algo deu errado ao buscar escopos!');
            return { scopes: {} };
        }
    };

    const { data, isLoading, error } = useQuery({
        queryKey: ['api-scopes'],
        queryFn: getScopes,
        enabled,
    });

    const scopesArray = !isLoading && data?.scopes
        ? Object.entries(data.scopes).map(([name, label]) => ({
            name,
            label,
        }))
        : [];

    return {
        scopes: scopesArray,
        isLoading,
        error,
    };
}
